import { render, staticRenderFns } from "./SelectTransactionMerchant.vue?vue&type=template&id=70637532&lang=pug"
import script from "./SelectTransactionMerchant.vue?vue&type=script&lang=js"
export * from "./SelectTransactionMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports